/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import GroupsIcon from '@mui/icons-material/Groups';
import type { MenuListItemProps } from './menu-list';
import { CheckboxProps } from './__fixtures__';

interface Props {
  readonly item: MenuListItemProps;
  readonly divider: boolean;
  readonly isChecked: boolean;
  readonly labelID: string;
  readonly onToggle: (item: MenuListItemProps) => void;
  readonly isDisabled?: boolean;
  readonly isRestrictive?: boolean;
}

export default function MenuListItem({ item, ...props }: Props) {
  const handleToggle = () => {
    if (item.isDisabled || props.isDisabled || props.isRestrictive) {
      return;
    }
    props.onToggle(item);
  };
  return (
    <ListItem
      key={props.labelID}
      data-testid="menu-list-item"
      disablePadding
      {...(props.divider && {
        divider: true,
      })}
    >
      <ListItemButton
        dense
        disabled={item.isDisabled || props.isDisabled || props.isRestrictive}
        onClick={handleToggle}
      >
        <ListItemIcon sx={{ minWidth: 0 }}>
          <Checkbox
            checked={props.isChecked || item.isDisabled || props.isRestrictive || false}
            inputProps={{ 'aria-label': props.labelID }}
            {...CheckboxProps}
          />
        </ListItemIcon>
        <ListItemText
          primary={item.primaryText}
          primaryTypographyProps={{ noWrap: true }}
          secondary={item.secondaryText}
          secondaryTypographyProps={{ noWrap: true }}
          sx={{ flex: '1 1 auto', minWidth: 0 }}
        />
        {item.caption && (
          <>
            {props.isRestrictive && (<GroupsIcon sx={{ flexShrink: 0 }} />)}
            <Typography variant="caption" marginLeft={2} noWrap sx={{ flexShrink: 0 }}>
              {item.caption}
            </Typography>
          </>
        )}
      </ListItemButton>
    </ListItem>
  );
}
